import { render, staticRenderFns } from "./StayOnTop.vue?vue&type=template&id=204f1146"
import script from "./StayOnTop.vue?vue&type=script&lang=js"
export * from "./StayOnTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports